import React, { useEffect, useState } from "react";
import {
	Link 
} from "react-router-dom";
import {Form, Row, Table, InputGroup} from 'react-bootstrap';
import './syllabus.css';
import '../css/main-style.css';
import {getData} from '../middleware/apiMiddleware';
import { useNavigate } from "react-router-dom";

export default function Syllabus() {
	const navigate = useNavigate();
	
	const [displayFlag, setDisplayFlag] = useState(
		{
			"noMaterial":true,
			"showWriting":false,
			"showReading":false,
		}
	);

	const gotoSyllabusDetail = (codeId) => {
		navigate('/syllabus/' + codeId);
	}

	function TitleRow({title, id, data}) {
		const[flag, setFlag] = useState(true);
		
		return (<div className="syllabusCard" id={id}>				
							<li id="header" className="syllabusCardDetail1">
								<ul>
									<div className="toggle" onClick={()=>{setFlag((p)=>(!p))}}>
										{(flag) && <div>-</div>}{!(flag) && <div>+</div>}
									</div>
								</ul>
								<ul>{title}</ul>
							</li>
							<div className={(flag) ? "ses-enabled":"ses-disabled"}>
							{	data.map((d, index)=>(
								<div className="sub-cat-div-holder" key={d.codeId + index}>
									<div className="sub-cat-div" >
										<div style={{marginLeft:"5px"}}>{d.codeId} </div>
										<div onClick={() => gotoSyllabusDetail(d.codeId)} className="general-green-btn general-green-btn-default">GOTO</div>
									</div>
									<li className="sub-cat-li">
										<ul className="sub-cat-ul">{d.subCatEn}</ul>
											{(d.subCatEn != d.subCatHk) && <ul className="sub-cat-ul">{d.subCatHk}</ul>}
										<ul className="syllabus-ul-holder">{d.syllabus.map((s, i2) => (
												<li key={s.sid} className={"syllabus-li " + ((s.itemCnt==0)?" syllabus-li-red" : "")}>
													<ul className="syllabus-ul">Sid:{s.sid}</ul>
													<ul className="syllabus-ul">Level:{s.rcLevel}</ul>
													<ul className="syllabus-ul">({s.itemCnt})</ul>
												
												</li>
											))}
										</ul>
									</li>
								</div>
								))
							}
							</div>
						</div>);
	}

	function CheckBox({label, flagKey, flag, setFlag, ...props}) {
		return (<div className="checkbox-wrapper">
			<label>
				<input
					type="checkbox"
					checked={flag}
					onChange={() => setFlag((prev) => ({...prev, [flagKey]: !flag}))}
					className={flag ? "checked" : ""}
					{...props}
				/>
				<span>{label}</span>
			</label>
		</div>);
	}







	function filterSubData(input) {
		let output = [];
		input.forEach((data)=>{
			let { syllabus, ...obj } = data
			
			
			if (displayFlag.showWriting) {
				if (!data.codeId.toLowerCase().includes('writing')) {
					return;
				}
			}
			if (displayFlag.showReading) {
				if (!data.codeId.toLowerCase().includes('reading')) {
					return;
				}
			}

			const newSyllabus = syllabus.filter(value => {
				if (displayFlag.noMaterial && value.itemCnt==0) {
					return false;
				}
				return true;
					
			});
			if (newSyllabus.length>0) {
				obj.syllabus = newSyllabus;
				output.push(obj);
			}
		})
		return output;
	}
	
	const processData = (obj) => {
		if (!obj) {
			return;
		}
		let newData = {
			engSyllabus: {
				nativeLang:filterSubData(obj.engSyllabus.nativeLang),
				bilLang:filterSubData(obj.engSyllabus.bilLang),
			},
			chiSyllabus: {
				cantoneseLang:filterSubData(obj.chiSyllabus.cantoneseLang),
				mandarinLang:filterSubData(obj.chiSyllabus.mandarinLang),
			},
			others:filterSubData(obj.others)
		}
		setState(newData);
	}
	
	const [rawData, setRawData] = useState();
	
	const [state, setState] = useState({ 
		engSyllabus: {
			nativeLang:[],
			bilLang:[],
		},
		chiSyllabus: {
			cantoneseLang:[],
			mandarinLang:[],
		},
		others:[]
	});
	
	 const handleClickScroll = (section) => {
    const element = document.getElementById(section);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
	
	const fetchData = () => {		
		getData('syllabus/listSyllabusTopic', navigate)
		.then(res => {
				let obj = { 
					engSyllabus: {
						nativeLang:[],
						bilLang:[],
					},
					chiSyllabus: {
						cantoneseLang:[],
						mandarinLang:[],
					},
					others:[]
				};
				
				res.data.map((d)=>{
					if (d.codeSubject=='english' && d.langType == 'Bilingual-class') {
						obj.engSyllabus.bilLang.push(d);
					} else if (d.codeSubject=='english' && d.langType == 'Native-speaker-teacher-class') {
						obj.engSyllabus.nativeLang.push(d);
					} else if (d.codeSubject=='chinese' && d.langType == 'Mandarin') {
						obj.chiSyllabus.mandarinLang.push(d);
					} else if (d.codeSubject=='chinese' && d.langType == 'Cantonese') {
						obj.chiSyllabus.cantoneseLang.push(d);
					} else {
						obj.others.push(d);
					}
				});
				
				setRawData(obj);
				processData(obj);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	useEffect(() => {
		processData(rawData);
	}, [displayFlag]);
	
	
	return (
		<div id="container">		
			<div id="scroll-top" onClick={()=>{window.scrollTo(0,0)}}>UP</div>
			
			
			<li id="container-header">
				<ul className="billBtn billBtn-default" onClick={()=>handleClickScroll('section-1')}>英文(Native)</ul>
				<ul className="billBtn billBtn-default" onClick={()=>handleClickScroll('section-2')}>英文(Bilingual)</ul>
				<ul className="billBtn billBtn-default" onClick={()=>handleClickScroll('section-3')}>中文(Cantonese)</ul>
				<ul className="billBtn billBtn-default" onClick={()=>handleClickScroll('section-4')}>中文(Mandarin)</ul>
			</li>
			
			<div style={{fontSize:"12px", textAlign:"left"}}>related table[course_classroom_description_code]</div>
			<div className="checkbox-holder">
				<CheckBox label="no material" flagKey="noMaterial" flag={displayFlag.noMaterial} setFlag={setDisplayFlag}/>
				<CheckBox label="writing" flagKey="showWriting" flag={displayFlag.showWriting} setFlag={setDisplayFlag}/>
				<CheckBox label="reading" flagKey="showReading" flag={displayFlag.showReading} setFlag={setDisplayFlag}/>
			</div>
			
			<TitleRow title="英文(Native)" id="section-1" data={state.engSyllabus.nativeLang}/>
			<TitleRow title="英文(Bilingual)" id="section-2" data={state.engSyllabus.bilLang}/>
			<TitleRow title="中文(Cantonese)" id="section-3" data={state.chiSyllabus.cantoneseLang}/>
			<TitleRow title="中文(Mandarin)" id="section-4" data={state.chiSyllabus.mandarinLang}/>
			
		</div>
  );
}